import { render, staticRenderFns } from "./SchoolLetter.vue?vue&type=template&id=76007834&scoped=true&"
import script from "./SchoolLetter.vue?vue&type=script&lang=js&"
export * from "./SchoolLetter.vue?vue&type=script&lang=js&"
import style0 from "./SchoolLetter.vue?vue&type=style&index=0&id=76007834&prod&scoped=true&lang=css&"
import style1 from "./SchoolLetter.vue?vue&type=style&index=1&id=76007834&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76007834",
  null
  
)

export default component.exports